<template>
  <whaty-dialog
    :title="'请选择要导出的数据'"
    :visible.sync="visible"
    width="700px">
    <div class="popup-wrap" slot="body">
      <div class="popup-body">
        <div class="popup-content popup-content-simple">
          <div class="form-row form-pretitle">
            <div class="form-tit">标题</div>
            <!--input-->
            <div class="form-con">
              <div class="input-wrap">
                <input type="text" v-model="exportFileName" class="form-control" :placeholder="gridConfig.title">
              </div>
            </div>
            <!--input end-->
          </div>
          <div class="form-row form-pretitle">
            <div class="form-tit">格式</div>
            <!--radio-->
            <div class="form-con">
              <div class="radio-wrap">
                <label class="form-label">
                  <input type="radio" v-model="exportType" value="excel" checked>
                  <div class="form-label-con">Excel</div>
                </label>
                <label class="form-label">
                  <input type="radio" v-model="exportType" value="dbf">
                  <div class="form-label-con">DBF</div>
                </label>
              </div>
            </div>
            <!--radio end-->
          </div>
          <div class="form-row form-pretitle">
            <div class="form-tit">范围</div>
            <!--radio-->
            <div class="form-con">
              <div class="radio-wrap">
                <label class="form-label">
                  <input type="radio" v-model="exportScope" value="select">
                  <div class="form-label-con">已选（<span class="primary">{{selectRow}}</span>）</div>
                </label>
                <label class="form-label">
                  <input type="radio" v-model="exportScope" value="current" checked>
                  <div class="form-label-con">当前页（<span class="primary">{{ pageSize < totalCount ? pageSize : totalCount }}</span>）</div>
                </label>
                <label class="form-label">
                  <input type="radio" v-model="exportScope" value="total">
                  <div class="form-label-con">全部（<span class="primary">{{totalCount}}</span>）</div>
                </label>
              </div>
            </div>
            <!--radio end-->
          </div>
          <div class="form-row form-pretitle">
            <div class="form-tit">列表</div>
            <!--input-->
            <div class="form-con">
              <div class="select-list" style="overflow-y: auto;overflow-x: auto;height: 200px;">
                <el-scrollbar class="whaty-scroll">
                  <ul class="drop-list-wrap">
                    <template v-if="exportColumns.length > 0">
                      <li v-for="item in exportColumns" :key="item.dataIndex" class="drop-list">
                        <a @click="handlerSelectColumns(item)" href="javascript:" class="drop-link" :class="{'drop-select': item.isSelectExport}">
                          <span class="drop-txt">{{ item.name }}</span>
                          <i class="mng icon-tick-stroke drop-ico-suf drop-ico-tick"></i>
                        </a>
                      </li>
                    </template>
                    <li v-else style="height: 100%; line-height: 100px; text-align: center;">
                      没有可导出列！
                    </li>
                  </ul>
                </el-scrollbar>
              </div>
            </div>
            <!--input end-->
          </div>
        </div>
        <div class="popup-foot">
          <a href="javascript:" class="btn btn-solid" @click="handleSubmit">导出</a>
          <a href="javascript:" class="btn btn-hollow" @click="handleCancel">取消</a>
        </div>
      </div>
    </div>
  </whaty-dialog>
</template>
<script>
  import util from '../../libs/util'
  import WhatyDialog from '../dialog/dialog'

  let _ = require('lodash')

  export default {
    name: 'grid-export',
    components: {WhatyDialog},
    props: {
      pageSize: '',
      curPage: '',
      totalCount: '',
      orderItem: {
        type: Array,
        default () {
          return []
        }
      },
      selectRow: '',
      gridConfig: {},
      gridParams: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        visible: false, // 组件是否可见
        exportFileName: '', // 导出文件的名称
        exportType: 'excel', // 导出格式,默认为excel,(excel/dbf)
        exportScope: 'current', // 导出的数据范围,默认为当前页(select/current/total)
        exportColumns: [] // 要导出的列
      }
    },
    created() {
      this.initExportColumns()
    },
    computed: {
      gridConfigUrl: function () {
        return this.$route.meta.url
      },
      // 导出的接口地址
      abstractExportUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'abstractExport')
      },
      // 下载文件的接口地址
      downFileUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'abstractDown')
      }
    },
    methods: {
      // 显示
      show() {
        this.visible = true
      },
      // 隐藏
      hide() {
        this.visible = false
      },
      // 初始化导出的列
      initExportColumns() {
        let gridColumns = this.gridConfig.listColumnConfig
        if (gridColumns && gridColumns.length > 0) {
          // 复制一个数组,避免对对象修改时影响父级组件中的数据
          let newGridColumns = JSON.parse(JSON.stringify(gridColumns))
          this.exportColumns = newGridColumns.filter((item) => {
            if (item.report) {
              this.$set(item, 'isSelectExport', true)
              return true
            }
            return false
          })
        }
      },
      // 选择导出列
      handlerSelectColumns(column) {
        this.$set(column, 'isSelectExport', !column.isSelectExport)
      },
      // 取消
      handleCancel() {
        this.hide()
      },
      // 导出
      handleSubmit() {
        // 判断是否选择了导出的列
        let selectExportColumns = []
        this.exportColumns.forEach((item) => {
          if (item.isSelectExport) {
            let dataIndex = item.dataIndex
            selectExportColumns.push({key: dataIndex, title: item.name})
          }
        })
        if (selectExportColumns.length === 0) {
          this.$notify.error({title: '错误', message: '没有可导出列！'})
          return
        }
        let page = {}
        let params = {}
        if (this.exportScope === 'select') { // 导出已选
          if (this.$parent.checkedRows.length <= 0) {
            this.$notify.error({title: '错误', message: '已选行数为0'})
            return
          }
          // 导出已选使用导出当前页逻辑,再从当前页中检索到ids匹配的记录
          page = {
            curPage: this.curPage,
            pageSize: this.pageSize,
            orderItem: this.orderItem,
            searchItem: this.$parent.processSearchParams()
          }
          params.checkIds = this.$parent.checkedRows
        } else if (this.exportScope === 'current') { // 导出当前页
          page = {
            curPage: this.curPage,
            pageSize: this.pageSize,
            orderItem: this.orderItem,
            searchItem: this.$parent.processSearchParams()
          }
        } else { // 导出全部
          page = {
            curPage: 1,
            pageSize: this.totalCount,
            orderItem: this.orderItem,
            searchItem: this.$parent.processSearchParams()
          }
        }
        let fileName = this.exportFileName || this.gridConfig.title || '数据'
        fileName += this.exportType === 'excel' ? '.xls' : '.dbf'
        _.assign(params, {
          actionId: this.gridConfig.gridId,
          exportType: this.exportType,
          exportScope: this.exportScope,
          exportColumns: selectExportColumns
        }, this.gridParams)
        util.ajax.post(this.abstractExportUrl, {page: page, params: params}).then((res) => {
          if (res.data.meta.errCode === 0) { // 提交form下载文件
            util.fileDown(util.baseUrl + this.downFileUrl, res.data.data.fileDownloadPath, fileName)
            this.$notify.success({title: '成功', message: '导出成功'})
          } else {
            this.$notify.error({title: '错误', message: '导出失败，原因：' + res.data.meta.errMsg})
          }
        }).catch((e) => {
          console.error(e)
          this.$notify.error({title: '错误', message: '导出失败'})
        })
      }
    },
    watch: {
      gridConfig() {
        this.initExportColumns()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/grid/grid-export.vue